import React, { FunctionComponent, ReactElement, useCallback, useEffect, useState } from 'react';
import { nextFeatureSelectionIdVar } from '../../../../../../gqlCommon/graphql/cache';
import VariantSelectorItem from './VariantSelectorItem';

export interface IVariantSelectorItemContainerProps {
  modelName?: string;
  variantName: string;
  selected: boolean;
  selectVariantId: (variantId: string) => void;
  id: string;
  detailsSlot: ReactElement;
}

const VariantSelectorItemContainer: FunctionComponent<IVariantSelectorItemContainerProps> = ({
  modelName,
  variantName,
  selected,
  selectVariantId,
  id,
  detailsSlot,
}) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(selected);
  }, [selected]);

  const selectVariantTab = useCallback(
    (isSelected: boolean) => {
      if (!isSelected) {
        return setExpanded(false);
      }

      setExpanded(true);

      if (!selected) {
        selectVariantId(id);
        nextFeatureSelectionIdVar(null);
      }
    },
    [setExpanded, id, selectVariantId, selected],
  );

  return (
    <VariantSelectorItem
      expanded={expanded}
      selected={selected}
      selectVariantTab={selectVariantTab}
      modelName={modelName}
      variantName={variantName}
      detailsSlot={detailsSlot}
    />
  );
};

export default VariantSelectorItemContainer;
